<script setup lang="ts">
import { ref } from 'vue';
import type { FlightSchoolForm } from '@/types/FlightSchoolForm';
import type { UsaState } from '@/types/Address';
import SchoolForm from '@/components/AdminCenter/SchoolForm.vue';
import BreadCrumbs from '@/components/Utilities/BreadCrumbs.vue';

const formData = ref<FlightSchoolForm>({
    name: '',
    address: {
        line1: '',
        line2: '',
        city: '',
        state: '' as UsaState,
        country: 'US',
        postcode: '',
    },
    phone: '',
    certificateUuids: [],
    courseAcronyms: [],
    email: '',
    isVisible: null,
    isArchived: false,
});

</script>
<template>
    <div
        id="create-school"
        class="text-fsum-black"
    >
        <BreadCrumbs
            :bread-crumbs="[{label: 'School Directory', to: { name: 'schoolDirectory' }}]"
            current-page="Create A Flight School"
        />
        <header id="create-school-header">
            <h1 class="q-pb-none q-mb-xs fsum-generic-header">
                Create A Flight School
            </h1>
            <p class="q-pb-xl">
                Fill out the form below.
            </p>
        </header>
        <SchoolForm
            :form-data="formData"
            :button-label="'Create School'"
        />
    </div>
</template>
<style scoped>
#create-school {
    font-size: 16px;
    text-align: center;
}
header#create-school-header p {
    line-height: normal;
}
</style>
